import {
  DIRECTOR_SEMAFORO,
  SCORE_DISPLAY,
  SCORE_FORMAT,
} from '../constants/director-constants';

const UNGRADED = { status: 'ungraded', label: 'No calificado', color: 'gray' };

/**
 * Semáforo por porcentaje (score / maxPoints).
 *
 * `baseSemaforo` es el que calcula el backend: sólo se respeta cuando indica
 * que la nota aún no existe (`ungraded` / `unsynced`), porque esos estados no
 * dependen del porcentaje. El resto se recalcula aquí para no depender de los
 * umbrales absolutos del backend.
 */
export function getSemaforoByPercent(score, maxPoints, baseSemaforo) {
  if (baseSemaforo?.status === 'ungraded' || baseSemaforo?.status === 'unsynced') {
    return baseSemaforo;
  }

  const max   = Number(maxPoints ?? 0);
  const total = Number(score ?? 0);
  if (!max || max <= 0) return UNGRADED;

  const percent = (total / max) * 100;
  if (percent >= DIRECTOR_SEMAFORO.GREEN_MIN)  return { status: 'green',  label: 'Verde',    color: 'green' };
  if (percent >= DIRECTOR_SEMAFORO.YELLOW_MIN) return { status: 'yellow', label: 'Amarillo', color: 'yellow' };
  return { status: 'red', label: 'Rojo', color: 'red' };
}

/** Semáforo de una fila de rúbrica del detalle de evento. */
export function getRubricSemaforo(row) {
  if (!row?.isGraded || !row?.synced) return UNGRADED;
  return getSemaforoByPercent(row.grade, row.rubric?.maxPoints, null);
}

/** '91%' | '68/75' — devuelve null si no hay máximo con el que comparar. */
export function formatScore(score, maxPoints, format) {
  const max   = Number(maxPoints ?? 0);
  const total = Number(score ?? 0);
  if (!max || max <= 0) return null;

  if (format === SCORE_FORMAT.PUNTOS) return `${total}/${max}`;
  return `${Math.round((total / max) * 100)}%`;
}

export const showsNumber = (mode) =>
  mode === SCORE_DISPLAY.PUNTUACION || mode === SCORE_DISPLAY.AMBOS;

export const showsColor = (mode) =>
  mode !== SCORE_DISPLAY.PUNTUACION;

/** Lee la configuración del camp con fallback al comportamiento histórico. */
export function getScoreConfig(camp) {
  return {
    mode:   camp?.directorScoreDisplay ?? SCORE_DISPLAY.SEMAFORO,
    format: camp?.directorScoreFormat  ?? SCORE_FORMAT.PORCENTAJE,
  };
}
